
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giving-back",
      function () {
        return require("private-next-pages/giving-back.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giving-back"])
      });
    }
  